const initLightbox = () => {
  const lightbox = GLightbox({
    selector: '.js-lightbox',
    touchNavigation: true,
    keyboardNavigation: true,
    loop: true,
    svg: {
    next: `<svg width="35" height="20" viewBox="0 0 35 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 9.79999L33 9.79999" stroke="#222" stroke-width="2"/>
    <path d="M21 0.799988L33 9.79999L21 18.8" stroke="#222" stroke-width="2"/>
    </svg>
    `,
    prev: `<svg width="35" height="20" viewBox="0 0 35 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.666 9.79999L1.66602 9.79999" stroke="#222" stroke-width="2"/>
    <path d="M13.666 0.799988L1.66602 9.79999L13.666 18.8" stroke="#222" stroke-width="2"/>
    </svg>`
    }
  });

  // GLightbox のクリック前にフォーカスを外す
  document.addEventListener("click", (e) => {
    if (e.target.closest(".js-lightbox")) {
      e.target.blur();
    }
  });

  return lightbox;
};

export default initLightbox;
